import React from "react";
import "../ConsultSelect.scss";
import "./ConsultSelectEvent.scss";
import { useMediaQuery } from "react-responsive";

interface ConsultSelectBProps {
  title: string;
  titleEvent?: string;
  price: string;
  ogPrice?: string;
  monthPrice?: string;
  best?: boolean;
  onClick: any;
  type?: string;
  discount?: boolean;
}

const ConsultSelectB = ({
  title,
  titleEvent,
  price,
  ogPrice = "",
  monthPrice = "",
  best,
  onClick,
  type = "",
  discount = false,
}: ConsultSelectBProps) => {
  const isMobile = useMediaQuery({
    query: "(max-width: 700px)",
  });

  return (
    <div
      className="consult-select"
      id="type-b"
      onClick={onClick}
      style={isMobile ? { paddingLeft: "12px", paddingRight: "12px" } : {}}
    >
      <div className="flex flex-col w-full items-center justify-center">
        <div className="flex flex-row w-full justify-center items-center">
          <div className="whitespace-nowrap mr-auto text-[20px] font-[700] leading-[26px] text-[#454F5D] 1200r:text-[14px] 1200r:leading-[22px]">
            {title}
            <span className="text-[#E30000]">{titleEvent}</span>
          </div>
          <div className="pl-[8px] text-[18px] font-[700] leading-[26px] text-[#A1A1A1] line-through 1200r:text-[14px] 1200r:leading-[22px]">
            {ogPrice}
          </div>
          <img
            className="mx-[12px] 1200r:mx-[6px] 400r:mx-[2px] 1200r:w-[18px]"
            src="/assets/arrow-right.svg"
            alt=""
          />
          <div className="flex flex-col text-start">
            <div className="min-w-[100px] mt-[26px] 1200r:mt-[22px] mr-auto text-[24px] font-[700] leading-[20px] text-[#E30000] 1200r:text-[20px] 1200r:leading-[24px] 1200:tracking-wide">
              {monthPrice}
              <span className="text-[14px] 1200r:text-[12px]"> / 월</span>
            </div>
            <div className="whitespace-nowrap pb-[2px] text-[14px] font-[500] leading-[22px] text-[#404040] mt-auto 1200r:text-[11px] 1200r:leading-[18px] tracking-tighter">
              {price}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ConsultSelectB;
